import { getWindow } from '../getWindow';

/* It's worth calling out here we {officially} only support > 375px viewports.
   However - we can still have anything < 600px use ViewportType.Small rather than not capturing it. Why, you may ask?
   Otherwise, we end up using Medium or Large instead as we have a number of conditions that go ViewportType.Small ? doSomething : doSomethingElse */
export const Breakpoint = {
  large: 1280,
  medium: 600,
};

export type ViewportType = 'small' | 'medium' | 'large';

const largeQuery = `(min-width: ${Breakpoint.large}px)`;
const mediumQuery = `(min-width: ${
  Breakpoint.medium
}px) and (max-width: ${Breakpoint.large - 1}px)`;

export type MediaQueryResult = {
  large: MediaQueryList;
  medium: MediaQueryList;
};

type ViewportReturn = MediaQueryResult & {
  viewportType: ViewportType;
};

export const getViewportType = (result: MediaQueryResult): ViewportType => {
  if (result.large.matches) {
    return 'large';
  } else if (result.medium.matches) {
    return 'medium';
  } else {
    return 'small';
  }
};

export const getViewport = (win = getWindow()): ViewportReturn => {
  const result = {
    large: win.matchMedia(largeQuery),
    medium: win.matchMedia(mediumQuery),
  };
  return {
    viewportType: getViewportType(result),
    ...result,
  };
};
